/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class ShipmentBaseTypeListViewModel extends JSONable {
  uuid: string | null = null;
  owner: string | null = null;
  type: string | null = null;

}
